var _rect, _rect2, _rect3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedPostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#313131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "url(#paint0_radial_3706_31350)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99242 4H5.00758C4.45182 4 4 4.45182 4 5.00758V9.99242C4 10.5482 4.45182 11 5.00758 11H9.99242C10.5482 11 11 10.5482 11 9.99242V5.00758C11 4.45182 10.5482 4 9.99242 4ZM6.61599 4.42424H8.38349V6.19174H6.61599V4.42424ZM8.38349 8.38402H6.61599V6.61599H8.38349V8.38349V8.38402ZM4.42424 5.00758C4.42424 4.68568 4.68568 4.42424 5.00758 4.42424H6.19174V6.19174H4.42424V5.00758ZM4.42424 6.61599H6.19174V8.38349H4.42424V6.61599ZM6.19174 10.5758H5.00758C4.68568 10.5758 4.42424 10.3143 4.42424 9.99242V8.80826H6.19174V10.5758ZM8.38349 10.5758H6.61599V8.80826H8.38349V10.5758ZM10.5752 9.99242C10.5752 10.3143 10.3138 10.5758 9.99189 10.5758H8.80773V8.80826H10.5752V9.99242ZM10.5752 8.38402H8.80773V6.61599H10.5752V8.38349V8.38402ZM8.80773 6.19227V4.42424H9.99189C10.3138 4.42424 10.5752 4.68568 10.5752 5.00758V6.19174H8.80773V6.19227Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3706_31350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.67197 30.5597) rotate(-76.1253) scale(31.9932 53.1818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12714,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedPostIcon);
export default __webpack_public_path__ + "static/media/feedPostIcon.364631e1bdfdac69eee451fcbe53c641.svg";
export { ForwardRef as ReactComponent };